<template>
    <div>
        <el-row v-if="show_date_heji">
            <el-col :span="12">
                <el-form-item
                        label=""
                        :label-width="formLabelWidth">
                    <!--<span style="padding-right: 20px">共 {{format_actualpaymoney}}</span>-->
                    应付 <span class="payMoney">{{format_paymoney}}</span>
                    <!--<span class="bigmoney"> {{ bigyingfumoney }}</span>  吴建屏蔽，先不显示大写-->
                </el-form-item>
            </el-col>
            <el-col  :span="12">
                <el-form-item
                        label="实际支付日期"
                        :label-width="formLabelWidth" >
                    <el-date-picker
                            v-model="actualpaydate"
                            :value-format="'yyyy-MM-dd'"
                            type="date"
                            placeholder="选择日期"
                            :disabled="!formallowedit"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item  :label="paymethodData[0].method+'方式'" :label-width="formLabelWidth">
                    <el-select style="width: 90%"
                            v-model="paymethodData[0].categorycode"
                            placeholder="请选择" @change="changeBankname"
                            :required="true">
                        <el-option
                                v-for="item in paymethodSetList"
                                :key="item.unitguid"
                                :label="item.name"
                                :value="item.unitguid">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="支付凭证"
            :label-width="formLabelWidth" >
          <CommonUpload
            ref="attachOther"
            :multiple="true"
            :groupGuid="payguid" :disabled="!formallowedit"
            groupType="paymoneyattach" :showButtonName="'选择附件'"
            :limit="10"
            :showViewer="true"
          ></CommonUpload>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
</template>

<style scope>
    .bigmoney {
        color: #909399;
        margin-left: 20px;
        font-size: 14px;
    }

    .payMoney {
      color: #bf2c49;
      font-size: 14pt;
      font-weight: bolder;
    }
</style>
<script>
    import {getListNoPage} from "@/api/set/Category";
    import {getPayMoneyDataNoPage} from "@/api/pay/paymoney";
    import {convertToBigMoney, ConvertMoney} from "@/plugin/ordercommon";

    export default {
      name: "paymoney",
      props: {
        payguid: {
          default: ''
        },
        formname: {
          default: ''
        },
        formallowedit: {
          default: ''
        },
        paydate: {
          default: ''
        },
        paymoney: {
          default: ''
        },
        isFinancial: {
          default: false
        },
        tenantid: {
          default: ''
        },
      },
      data() {
        return {
          show_date_heji: this.formname == "收款" ? false : true,//显示日期和合计，收款时不要显示，付款时显示
          methodname: (this.formname == "收款" ? "到账" : "付款"),
          paymethodData: [
            {
              method: (this.formname == "收款" ? "到账" : "付款"),
              categorycode: "",
              enablebankconnect: false,
              categoryname: "",
              feemoney: "",
              paymoney: 0
            }
          ], //已经保存的付款方式和对应的金额
          paymethodSetList: [], //系统配置的付款方式
          formLabelWidth: "120px",
          bigpaymoney: "",
          format_paymoney: "", //千分符金额
          format_actualpaymoney: "",
          bigyingfumoney: "",
          actualpaymoney: 0, //实际支付金额
          actualpaydate: "", //实际支付日期
          paymethodTotalMoney: 0 //付款方式总额
        };
      },
      mounted() {
        //初始化金额
        this.initMoney();
        if (this.paydate) {
          this.actualpaydate = this.paydate;
        } else {
          var today = new Date();
          this.actualpaydate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
        }
        this.paymethodSetList = [];
        this.paymethodData[0].categorycode = ''
        if (this.formallowedit) {
          //获取付款方式配置信息categorytype:300 为付款方式
          getListNoPage({categorytype: "300", filltemplate: '', enabled: 1}).then(
            response => {
              for (let i in response.data.obj) {
                var row = response.data.obj[i];
                if (!row.filltemplate || row.filltemplate == this.tenantid) {
                  var huming='';
                  if(row.formproperty){
                    var form=JSON.parse(row.formproperty);
                    if(form.bankaccountname){
                      huming='【'+form.bankaccountname+ '】';
                    }
                  }
                  var itemadd = {
                    unitguid: row.unitguid,
                    name: huming+'【'+row.categoryname+ '】' + (row.accountcode ? ('【' + row.accountcode + '】') : '')
                  };
                  this.paymethodSetList.push(itemadd);

                  if (!this.paymethodData[0].categorycode) {
                    this.paymethodData[0].categorycode = itemadd.unitguid;
                    this.paymethodData[0].categoryname = itemadd.name;
                  }
                }
              }
            }
          );
        } else {
          this.getPayMoneyDataNoPage();
        }
      },
      methods: {
        changeBankname() {
          for (let i in this.paymethodSetList) {
            if (this.paymethodData[0].categorycode == this.paymethodSetList[i].unitguid) {
              this.paymethodData[0].categoryname = this.paymethodSetList[i].name;
              break;
            }
          }
        },
        //初始化金额
        initMoney() {
          //获取大写金额.及千分符金额
          this.format_paymoney = ConvertMoney(this.paymoney, 2);
        },
        //添加付款方式
        // addPaymethod: function () {
        //   this.paymethodTotalMoney = 0;
        //   this.paymethodData.forEach(element => {
        //     this.paymethodTotalMoney += parseFloat(element.feemoney);
        //   });
        //   this.paymethodData.push({
        //     method: this.methodname,
        //     feemoney: this.actualpaymoney - this.paymethodTotalMoney,
        //     categorycode: ""
        //   });
        // },
        //
        // //删除支付方式
        // removePaymethod: function (item) {
        //   var index = this.paymethodData.indexOf(item);
        //   if (index !== -1) {
        //     this.paymethodData.splice(index, 1);
        //   }
        //   if (this.paymethodData.length == 0) {
        //     this.addPaymethod();
        //   }
        // },
        // feemoneyFocus: function (event) {
        //   //默认全选中
        //   event.target.select();
        // },
        //获取已经保存的付款方式数据
        getPayMoneyDataNoPage: function () {
          this.paymethodSetList = [];
          if (this.payguid) {
            getPayMoneyDataNoPage({payguid: this.payguid}).then(response => {
              var dats = response.data.obj;
              if (dats.length > 0) {
                var itemadd = {
                  unitguid: dats[0].categorycode,
                  name: dats[0].categoryname
                };
                this.paymethodSetList.push(itemadd);
                this.paymethodData[0].categorycode = itemadd.unitguid;
                this.paymethodData[0].categoryname = itemadd.name;
              }
            });
          }
        },
      },
    };
</script>



// WEBPACK FOOTER //
// src/components/oa/payform/PayMoney.vue